import cls from 'classnames';
import React, { FC } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import { useState } from '../../state/store';
import ErrorContainer from '../ErrorContainer/ErrorContainer';
import { Confirmation, Details, NewDeviceCheck, OldDeviceModel, OldDeviceStatus, StepBreadcrumbs } from '../Steps';
import styles from './StepsContainer.module.css';

const StepsContainer: FC = () => {
  const { recaptchaKey } = useState('recaptchaKey');

  return (
    <div className={`${styles.StepsContainer} p-2 py-4 p-md-8`} data-testid="StepsContainer">
      <GoogleReCaptchaProvider reCaptchaKey={recaptchaKey}>
        <StepBreadcrumbs />
        <div className={cls('flex flex-col w-full')}>
          <NewDeviceCheck />
          <OldDeviceModel />
          <OldDeviceStatus />
          <Details />
          <Confirmation />
        </div>
        <ErrorContainer />
      </GoogleReCaptchaProvider>
    </div>
  );
};

export default StepsContainer;
